import { type PropsWithChildren } from 'react';

import { DownloadData } from './DownloadData.js';
import type { ChartToolbarProps } from '../../types/toolbar.js';

/**
 * ChartToolbar slot component.
 */
const ChartToolbarRoot = ({
  children,
}: PropsWithChildren<ChartToolbarProps>) => (
  // eslint-disable-next-line react/jsx-no-useless-fragment
  <>{children}</>
);

ChartToolbarRoot.displayName = 'ChartToolbar';

/**
 * ChartToolbar Slots
 * @public
 */
export const ChartToolbar = Object.assign(ChartToolbarRoot, {
  DownloadData,
});
